var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mbri-close",
    transform: "translate(3.000000, 3.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5771641,8.28640855e-07 C23.473212,0.0031995716 23.3756569,0.0455829158 23.3028904,0.119953689 L13.725702,9.70018884 C13.3338825,10.0760411 13.9136155,10.6574127 14.290242,10.2655667 L23.8666307,0.685331507 C24.126511,0.431031442 23.9465939,8.28640855e-07 23.5763644,8.28640855e-07 L23.5771641,8.28640855e-07 Z M9.98662438,13.5946584 C9.88267227,13.5978571 9.78671647,13.6410402 9.71474962,13.7146113 L0.130364551,23.3028433 C-0.258256435,23.6762965 0.316678728,24.2512705 0.690106713,23.8626233 L10.2744918,14.2743913 C10.5343721,14.0240896 10.3488575,13.5946584 9.98662438,13.5946584 Z M0.400640052,8.28315344e-07 C0.2374418,-0.000330172351 0.0904234485,0.0985675278 0.0292069156,0.249859995 C-0.0320096173,0.401152463 0.0048649161,0.574467666 0.122368235,0.687730564 L23.3020908,23.8666217 C23.4008475,23.9771064 23.5526075,24.0239055 23.6964313,23.988227 C23.8402552,23.9525484 23.9525516,23.8402444 23.9882278,23.6964108 C24.0239039,23.5525772 23.9771079,23.4008069 23.8666307,23.3020436 L0.68850745,0.121553061 C0.613012023,0.0436610699 0.509110583,-0.000211394235 0.400640052,8.28315344e-07 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.465e25e023f74d528dc547fced6a1522.svg";
export { ForwardRef as ReactComponent };